import React, { Component } from 'react'

export class Numeric extends Component {
  render() {
    let hintClasses = ['text-sm', 'hint']

    if (this.props.showHint === false) hintClasses.push('hidden')

    return (
      <div style={Object.assign({ display: 'flex', alignItems: 'center' })}>
        <input
          className="form-control"
          type="number"
          style={{ maxWidth: 100 }}
          min={this.props.min || 0}
          max={this.props.max || 100}
          step={this.props.step || 1}
          value={this.props.value}
          onChange={(e) => this.props.onChange(e.target.value)}
          onWheel={(e) => {
            e.preventDefault()
            e.currentTarget.blur()
          }}
        />
        <div
          className={hintClasses.join(' ')}
          style={{ marginLeft: 20, maxWidth: 400 }}
        >{`Please enter a value between ${this.props.min} and ${this.props.max}`}</div>
      </div>
    )
  }
}
/*
 * Handles imperial/metric conversion.  Stores data in metric (meters)
 */
export class Weight extends Component {
  constructor(props) {
    super(props)

    let pounds = props.value * 2.20462

    if (pounds <= 0) {
      pounds = ''
    } else {
      pounds = pounds.toFixed(2)
    }
    this.state = {
      pounds: pounds || '',
      kilos: props.value || '',
    }
  }

  handleWeightChange = (unit, value) => {
    let kilos
    let pounds
    switch (unit) {
      case 'imperial':
        pounds = value * 1
        kilos = value / 2.20462
        break
      case 'metric':
      default:
        kilos = value * 1
        pounds = value * 2.20462
        break
    }

    if (kilos <= 0) kilos = ''
    if (pounds <= 0) pounds = ''

    this.setState({ kilos: kilos || '', pounds: pounds || '' })
    this.props.onChange(kilos)
  }
  render() {
    let hintClasses = ['text-sm', 'hint']

    if (this.props.showHint === false) hintClasses.push('hidden')

    return (
      <div style={Object.assign({ display: 'flex', alignItems: 'center' })}>
        <input
          className="form-control"
          type="number"
          style={{ maxWidth: 100 }}
          min={this.props.min || 0}
          max={this.props.max || 100}
          step={this.props.step || 1}
          value={this.props.unit === 'imperial' ? this.state.pounds : this.state.kilos}
          onChange={(e) => this.handleWeightChange(this.props.unit, e.target.value)}
        />{' '}
        {this.props.unit === 'imperial' ? 'Pounds' : 'Kilograms'}
        <div
          className={hintClasses.join(' ')}
          style={{ marginLeft: 20, maxWidth: 400 }}
        >{`Please enter a value between ${this.props.min} and ${this.props.max}`}</div>
      </div>
    )
  }
}
/*
 * Handles imperial/metric conversion.  Stores data in metric (meters)
 */
export class Height extends Component {
  constructor(props) {
    super(props)

    let inches = (props.value * 39.37).toFixed(0)
    var feet = Math.floor(inches / 12)
    inches %= 12

    this.state = {
      feet: feet || '',
      inches: inches || '',
      meters: props.value || '',
    }

    console.log('start state', this.state)
  }

  handleHeightChange = (unit, value) => {
    let calcmeters
    let totalInches
    let inches
    let feet
    switch (unit) {
      case 'inch':
        feet = this.state.feet
        totalInches = value * 1 + feet * 12
        calcmeters = totalInches / 39.37
        inches = value * 1
        this.setState({ inches: inches })
        break
      case 'foot':
        inches = this.state.inches
        totalInches = inches * 1 + value * 12
        calcmeters = totalInches / 39.37
        feet = value * 1
        this.setState({ feet: value * 1 })
        break
      case 'meter':
      default:
        inches = (value * 39.37).toFixed(0)
        feet = Math.floor(inches / 12)
        inches %= 12
        calcmeters = value * 1
        break
    }

    if (inches <= 0) inches = ''
    if (feet <= 0) feet = ''
    if (calcmeters <= 0) calcmeters = ''

    this.setState({ meters: calcmeters, inches: inches, feet: feet })
    this.props.onChange(calcmeters)
  }

  render() {
    let hintClasses = ['text-sm', 'hint']

    if (this.props.showHint === false) hintClasses.push('hidden')

    if (this.props.unit === 'imperial') {
      return (
        <div style={Object.assign({ display: 'flex', alignItems: 'center' })}>
          <div style={{ display: 'flex', alignItems: 'center', margin: '0 10px 0 0' }}>
            <input
              className="form-control"
              type="number"
              style={{ maxWidth: 100 }}
              min={this.props.min || 0}
              max={this.props.max || 100}
              step={this.props.step || 1}
              value={this.state.feet}
              onChange={(e) => this.handleHeightChange('foot', e.target.value)}
            />
            /ft{' '}
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <input
              className="form-control"
              type="number"
              style={{ maxWidth: 100 }}
              min={this.props.min || 0}
              max={this.props.max || 100}
              step={this.props.step || 1}
              value={this.state.inches}
              onChange={(e) => this.handleHeightChange('inch', e.target.value)}
            />
            /in
          </div>
        </div>
      )
    } else {
      return (
        <div style={Object.assign({ display: 'flex', alignItems: 'center' })}>
          <input
            className="form-control"
            type="number"
            style={{ maxWidth: 100 }}
            min={this.props.min || 0}
            max={this.props.max || 100}
            step={this.props.step || 1}
            value={this.props.value}
            onChange={(e) => this.handleHeightChange('meter', e.target.value)}
          />
          / meters
        </div>
      )
    }
  }
}

export class Text extends Component {
  render() {
    return (
      <div style={Object.assign({ display: 'flex', alignItems: 'center' })}>
        <input
          style={this.props.style}
          className="form-control"
          type="text"
          value={this.props.value}
          onChange={(e) => this.props.onChange(e.target.value)}
        />
        {this.props.hint && (
          <div className="text-sm hint" style={{ marginLeft: 20, maxWidth: 400 }}>
            {this.props.hint}
          </div>
        )}
      </div>
    )
  }
}

export class Date extends Component {
  render() {
    return (
      <div style={this.props.style}>
        <input
          className="form-control"
          type="date"
          value={this.props.value}
          onChange={(e) => this.props.onChange(e.target.value)}
        />
      </div>
    )
  }
}

export class Radio extends Component {
  render() {
    return (
      <div style={Object.assign({ display: 'flex' }, this.props.style)}>
        {this.props.options.map(([optionLabel, optionValue], idx) => (
          <div key={idx} className="form-check" style={{ marginLeft: idx > 0 ? 20 : 0 }}>
            <input
              id={`${this.props.id}-${optionValue}`}
              className="form-check-input"
              type="radio"
              checked={this.props.value === optionValue}
              onChange={() => this.props.onChange(optionValue)}
            />
            <label htmlFor={`${this.props.id}-${optionValue}`} className="form-check-label">
              {optionLabel}
            </label>
          </div>
        ))}
      </div>
    )
  }
}

export class SelectMultiple extends Component {
  render() {
    return (
      <div style={Object.assign({ display: 'flex', flexWrap: 'wrap' }, this.props.style)}>
        {this.props.options.map(([optionLabel, optionValue], idx) => (
          <div key={idx} className="form-check" style={{ marginRight: 20 }}>
            <input
              id={`${this.props.id}-${optionValue}`}
              className="form-check-input"
              type="checkbox"
              checked={this.props.value.indexOf(optionValue) !== -1}
              onChange={() => {
                let value = [].concat(this.props.value)
                if (this.props.value.indexOf(optionValue) !== -1) {
                  value = value.filter((v) => v !== optionValue)
                } else {
                  value.push(optionValue)
                }
                this.props.onChange(value)
              }}
            />
            <label htmlFor={`${this.props.id}-${optionValue}`} className="form-check-label">
              {optionLabel}
            </label>
          </div>
        ))}
      </div>
    )
  }
}

export class Boolean extends Component {
  render() {
    return (
      <div style={Object.assign({ display: 'flex' }, this.props.style)}>
        <div className="form-check">
          <input
            id={`${this.props.id}-false`}
            className="form-check-input"
            type="radio"
            checked={this.props.value === false}
            onChange={() => this.props.onChange(false)}
          />
          <label htmlFor={`${this.props.id}-false`} className="form-check-label">
            No
          </label>
        </div>
        <div className="form-check" style={{ marginLeft: 20 }}>
          <input
            id={`${this.props.id}-true`}
            className="form-check-input"
            type="radio"
            checked={!!this.props.value}
            onChange={() => this.props.onChange(true)}
          />
          <label htmlFor={`${this.props.id}-true`} className="form-check-label">
            Yes
          </label>
        </div>
      </div>
    )
  }
}
